module.exports = __webpack_public_path__ + "static/media/calendarDate.03b96468.svg";